'use strict';

import register from './core';
import '../functions/jquery-global.js';

$.extend($.easing, {
  easeInOutQuad: function (x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
    return -c / 2 * ((--t) * (t - 2) - 1) + b;
  }
});

register('cookie-consent', function (element) {
  var consent = document.cookie.replace(/(?:(?:^|.*;\s*)CONSENT\s*\=\s*([^;]*).*$)|^.*$/, "$1");

  if (consent !== 'all' && consent !== 'necessary') {
    deleteAllCookies(); // delete all cookies from previous consent
    $(element).show().attr('aria-expanded', 'true');
  }
  $('#cookie-consent').one('click', function () {
    setCookie('all');
  });

  $('#cookie-consent-necessary').one('click', function () {
    setCookie('necessary');
  });

  function setCookie(val) {
    var CookieDate = new Date;
    CookieDate.setFullYear(CookieDate.getFullYear() + 1); // expire cookie after one year
    document.cookie = 'CONSENT=' + val + '; expires=' + CookieDate.toUTCString() + '; path=/';
    loadCookieScripts();
    hideCookieBanner();
  }

  function deleteAllCookies() {
    var cookies = document.cookie.split("; ");
    for (var c = 0; c < cookies.length; c++) {
      var d = window.location.hostname.split(".");
      while (d.length > 0) {
        var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        var p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        };
        d.shift();
      }
    }
  }
  function hideCookieBanner() {
    var cookieBanner = document.getElementsByClassName("cookie-information");
    cookieBanner[0].style.display = "none";
  }

  function loadCookieScripts() {
    if (consent === 'necessary' || consent === 'all') {
      var script = document.createElement('script');
      script.src = 'https://siteimproveanalytics.com/js/siteanalyze_7611.js';
      script.async = true;
      document.head.appendChild(script);
    };
  }
});
